import { CloseButton, Group, Stack } from "@mantine/core"
import { type ContextModalProps, openContextModal } from "@mantine/modals"
import { IconLink } from "@tabler/icons-react"
import { UserSessionLink } from "@/components/sessions"
import { AppTitle } from "@/components/utils"
import type { TUserSession } from "@/types"
import { SurveyUserSessionDetails } from "./SurveyUserSessionDetails"

export function ModalUserSessionDetails({
  id,
  context,
  usersession,
}: ContextModalProps & { usersession: TUserSession }) {
  return (
    <Stack gap="sm">
      <Group wrap="nowrap">
        <UserSessionLink usersession={usersession} target="_blank">
          <AppTitle align="center">
            {usersession.session.title}
            <IconLink size={16} />
          </AppTitle>
        </UserSessionLink>
        <CloseButton ml="auto" onClick={() => context.closeContextModal(id as any)} />
      </Group>
      <SurveyUserSessionDetails usersession={usersession} />
    </Stack>
  )
}

export function useModalUserSessionDetails(usersession: TUserSession) {
  return () =>
    openContextModal({
      modal: "UserSessionDetails",
      size: "xl",
      withCloseButton: false,
      styles: {
        content: {
          backgroundColor: "var(--mantine-color-panel)",
        },
      },
      innerProps: { usersession },
    })
}
